
    import { defineComponent } from 'vue';
    import { useResultsStore } from '../../stores/citation-search-results';
    import { useUserStore } from './../../stores/user';
    import loginPage from '../LoginPage/login-page.vue';


    export default defineComponent({
        components: {
            loginPage
        },
        data() {
            const userStore = useUserStore();

            return {
                results: useResultsStore(),
                currentUser: userStore.user,
            }
        },
        computed: {
            minPayment(): number {
                return (this.results.Overview.PartialFeeFineContemptPaymentAmountDue || 0) + (this.results.Overview.PartialProbationPaymentAmountDue || 0);
            }
        },
        methods: {
             checkoutAsGuest() {
                this.$router.push({ name: 'checkout' });
            }
        },
        created() {
            if (this.currentUser != null && Object.keys(this.currentUser).length > 0) {
                this.$router.push({ name: 'checkout' });
            }
        },
    });

